import React from "react"

import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

export default ({ fulltext, isFetchingFulltext, summary, authors, license, isFetching }) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-article" />Article
            </h3>
            <ContentLoaderLines isFetching={isFetchingFulltext} lines={5}>
                <ShortTextWithReadMore
                    text={fulltext}
                    placeholder="No article content"
                />
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-article" />Article summary
            </h3>
            <ContentLoaderLines isFetching={isFetching} lines={5}>
                <ShortTextWithReadMore
                    text={summary}
                    placeholder="No article summary"
                />
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-authors" />Authors
            </h3>
            <div className="authors">
                <ContentLoaderTags isFetching={isFetching}>
                    {authors && authors.length > 0 ? (
                        <Tags>
                            {authors.map(author => (
                                <TagItem isGrey={true} key={author.id}>
                                    {author.label}
                                </TagItem>
                            ))}
                        </Tags>
                    ) : (
                        <p>No authors</p>
                    )}
                </ContentLoaderTags>
            </div>
            <h3>
                <span className="icon icon-license" />License
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={20}
                maxLineLength={60}
            >
                <p>{license || "No license"}</p>
            </ContentLoaderLines>
        </div>
    </div>
)
